import { formatPercentage } from "@goodfill/format-number";
import { ChartConfiguration } from "@goodfill/ui-components";
import { PortfolioDistribution } from "./PortfolioDistribution";
import { calculateRandomColorFromSeed } from "@goodfill/color";

export function createPortfolioDistributionChartConfiguration(
  portfolioDistribution: PortfolioDistribution,
): ChartConfiguration {
  return {
    type: "pie",
    data: {
      labels: portfolioDistribution.map(({ label }) => label),
      datasets: [
        {
          label: "Portfolio Distribution",
          backgroundColor: portfolioDistribution.map(({ id }) => calculateRandomColorFromSeed(id, "blue")),
          data: portfolioDistribution.map(({ percentage }) => percentage.toNumber()),
        },
      ],
    },
    options: {
      plugins: {
        tooltip: {
          callbacks: {
            label: (context) =>
              `${context.label} ${formatPercentage({
                value: context.parsed,
                numDecimals: 0,
              })}`,
          },
          padding: 12,
        },
      },
    },
  };
}
